<div class="grid table-demo">
  <div class="col-12">
    <div class="card mt-2">
      <div class="grid">
        <div class="formgrid grid">
          <div class="field col">
            <label class="font-bold">Seleccionar Tienda:</label>
            <p-autoComplete
              [(ngModel)]="storeSelected"
              [suggestions]="filteredLocations"
              (completeMethod)="filterLocations($event, 'STORE')"
              [minLength]="1"
              placeholder="{{ 'Buscar' | translate }}: "
              name="storeSale"
              #productionQuality="ngModel"
              [dropdown]="true"
              (onSelect)="onSelectStore($event)"
              field="display_name"
              dataKey="id"
              [disabled]="isDisabledFilters"
            >
            </p-autoComplete>
          </div>
          <div class="field col">
            <label class="font-bold">Seleccionar Showroom:</label>
            <p-autoComplete
              [(ngModel)]="showRoomSelected"
              [suggestions]="filteredLocations"
              (completeMethod)="
                filterLocations($event, 'SHOWROOM', storeSelected)
              "
              [minLength]="1"
              placeholder="{{ 'Buscar' | translate }}: "
              name="showRoomSale"
              #productionQuality="ngModel"
              [dropdown]="true"
              (onSelect)="onSelectShowRoom($event)"
              field="display_name"
              dataKey="id"
              [disabled]="isDisabledFilters || (storeSelected ? false : true)"
            >
            </p-autoComplete>
          </div>
          <div class="field col">
            <label class="font-bold">Seleccionar Rango de Fechas:</label>
            <p-calendar
              #rangeDate
              [(ngModel)]="rangeDates"
              selectionMode="range"
              dateFormat="dd/mm/yy"
              dataType="date"
              placeholder="{{ 'Rango de Fechas' | translate }}"
              [readonlyInput]="true"
              [showIcon]="true"
              (onClearClick)="clearFilters()"
              (onSelect)="selectDateRange(rangeDate.value)"
              [disabled]="showRoomSelected ? false : true"
            ></p-calendar>
          </div>
          <div class="field col">
            <!-- <label class="font-bold">Seleccionar Tipo:</label>
                  <p-dropdown
                    [options]="reportTypeAmount"
                    optionLabel="name"
                    dataKey="value"
                    (onChange)="selectAmountType($event)"
                    [disabled]="showRoomSelected ? false : true"
                  ></p-dropdown> -->
          </div>
        </div>
        <div class="col-12">
          <kanzi-progress-bar
            [show]="pendingList"
            [height]="'5px'"
          ></kanzi-progress-bar>
          <kanzi-floormap-viewer
            title="{{ 'Ventas por Locación' | translate }}"
            [dataReport]="dataReport"
            ></kanzi-floormap-viewer>
          </div>
          <!-- [dataGroup]="dataGroupFurniture" -->
          <!-- [locationSelected]="showRoomSelected" -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>
